import { Button, FormControl, FormLabel, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Services from "../../../api/services";
import Swal from "sweetalert2";

interface WithdrawCancelProps {
  handleClose: () => void;
  serviceBookingId: number;
  setServiceData: any;
}

const WithdrawService: React.FC<WithdrawCancelProps> = ({
  handleClose,
  serviceBookingId,
  setServiceData,
}) => {
  const [isWithdraw, setIsWithdraw] = useState(false);

  const formik = useFormik({
    initialValues: {
      reason: "",
    },
    validationSchema: Yup.object({
      reason: Yup.string().required("Reason is required"),
    }),
    onSubmit: async (values) => {
      if (values) {
        try {
          setIsWithdraw(true);
          const tokenString = localStorage.getItem("access_token");
          if (tokenString !== null) {
            const token = JSON.parse(tokenString);
            const data = {
              status: "withdraw",
              withdraw_reason: values.reason,
            };
            const options = {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            };
            const result = await Services.provider.updateUpcomingServicesData(
              serviceBookingId,
              data,
              options
            );
            if (result) {
              const response = await Services.customer.getMyServiceData(
                options
              );
              setServiceData(response.data.data);
            }
            Swal.fire({
              text: "Thank you for raising your concern, we will get back to you with more information soon.",
              icon: "success",
              confirmButtonColor: "#11b4f5",
            });
          }
          handleClose();
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setIsWithdraw(false);
        }
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack direction={"column"} spacing={2} sx={{ mt: 2 }}>
        <FormControl>
          <FormLabel sx={{ mb: 1 }}>Why do you want to withdraw?</FormLabel>
          <textarea
            id="form_reason"
            className="form-control"
            name="reason"
            placeholder="reason"
            rows={4}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.reason}
            style={{ height: "100px", resize: "none" }}
          ></textarea>
          {formik.touched.reason &&
            typeof formik.errors.reason === "string" && (
              <Typography className="error">{formik.errors.reason}</Typography>
            )}
        </FormControl>

        <Box sx={{ textAlign: "right" }}>
          <Button type="submit" variant="contained" disabled={isWithdraw}>
            {isWithdraw ? (
              <span style={{ color: "#837373" }}>Submitting...</span>
            ) : (
              "Submit"
            )}
          </Button>
        </Box>
      </Stack>
    </form>
  );
};

export default WithdrawService;
